import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FormGroupDirective, Validators } from '@angular/forms';
import { ValidatorService } from '../services/validator.service';

@Directive({
  selector: '[appInputOverview]'
})
export class InputOverviewDirective {
  private validators = this.validatorService.getValidatorForm();
  private controlName!: string;
  private created: boolean | undefined;

  constructor(
    private view: ViewContainerRef,
    private template: TemplateRef<any>,
    private fgDirective: FormGroupDirective,
    private validatorService: ValidatorService
  ) {
    this.validatorService.validators().subscribe((validators) => {
      this.validators = validators;
      this.resolveValidatorAndView();
    });

  }

  @Input() set appInputOverview(controlName: string) {
    if (!this.created) {
      this.controlName = controlName;
      this.resolveValidatorAndView();
    }
  }

  resolveValidatorAndView() {
    const form = this.fgDirective.form;
    if (!form || !this.validators) return;

    const control = form.controls[this.controlName];
    const validator = this.validators.find((v) => v.field === this.controlName);


    if (validator && !validator.visible) {
      control.setValidators([]);
      return;
    }

    this.view.createEmbeddedView(this.template);

    this.created = true;

    if (validator && validator.regex) {
      control.addValidators([Validators.pattern(validator.regex)]);
    }
  }
}
